import { StaticImage } from 'gatsby-plugin-image';

import { IngredientsInfoPopContent } from '../../IngredientsPop';

import {
  AZELAIC,
  CLINDAMYCIN,
  METRONIDAZOLE,
  MINOXIDIL,
  NIACINAMIDE,
  TRANEXAMIC,
  TRETINOIN,
  ZINC,
} from 'components/modules/Ingredients';

export enum IngredientInfoTags {
  DARK_SPOTS = 'Dark spots',
  INFLAMMATION = 'Inflammation',
  FINE_LINES = 'Fine lines',
  REDNESS = 'Redness',
  ACNE = 'Acne',
  HYPERPIGMENTATION = 'Hyperpigmentation',
  CLOGGED_PORES = 'Clogged pores',
  IMPROVE_TEXTURE = 'Improve texture',
  ROSACEA = 'Rosacea',
  HORMONAL_ACNE = 'Hormonal Acne',
  THINNING_HAIR = 'Thinning hair',
  PREVENTATIVE_HAIR_LOSS = 'Preventative hair loss',
  PREVENTATIVE_AGING = 'Preventative aging',
}

export const AZELIAC_POP: IngredientsInfoPopContent = {
  ...AZELAIC,
  iconImage: (
    <StaticImage
      src="../../images/azelaicAcid@2x.png"
      width={80}
      alt="azelaic acid"
    />
  ),
  shortName: 'Az A',
  tags: [
    IngredientInfoTags.ACNE,
    IngredientInfoTags.CLOGGED_PORES,
    IngredientInfoTags.IMPROVE_TEXTURE,
  ],
};

export const AZELIAC_ACNE: IngredientsInfoPopContent = {
  ...AZELIAC_POP,
  detailsText:
    'A multi-tasking exfoliant that helps unclog pores, smooth texture, and brighten skin.',
};

export const NIACINAMIDE_POP: IngredientsInfoPopContent = {
  ...NIACINAMIDE,
  detailsText:
    'A form of vitamin B3 that can soothe inflammation, help fade dark spots, and fight free radicals',
  iconImage: (
    <StaticImage
      src="../../images/niacinamide@2x.png"
      width={80}
      alt="niacinamide"
    />
  ),
  shortName: 'Ni',
  tags: [
    IngredientInfoTags.DARK_SPOTS,
    IngredientInfoTags.INFLAMMATION,
    IngredientInfoTags.FINE_LINES,
    IngredientInfoTags.REDNESS,
  ],
};

export const CLINDAMYCIN_POP: IngredientsInfoPopContent = {
  ...CLINDAMYCIN,
  iconImage: (
    <StaticImage
      src="../../images/clindamycin@2x.png"
      width={80}
      alt="clindamycin"
    />
  ),
  shortName: 'Cl',
  tags: [IngredientInfoTags.ACNE, IngredientInfoTags.REDNESS],
};

export const METRONIDAZOLE_POP: IngredientsInfoPopContent = {
  ...METRONIDAZOLE,
  detailsText:
    'An antimicrobial that can help soothe inflammation, including redness.',
  iconImage: (
    <StaticImage
      src="../../images/metronidazole@2x.png"
      width={80}
      alt="metronidazole"
    />
  ),
  shortName: 'Me',
  tags: [
    IngredientInfoTags.REDNESS,
    IngredientInfoTags.ROSACEA,
    IngredientInfoTags.INFLAMMATION,
  ],
};

export const TRETINOIN_POP: IngredientsInfoPopContent = {
  ...TRETINOIN,
  detailsText:
    'A vitamin A derivative that helps treat acne and smooth skin texture. Can improve dark spots and fine lines.',
  iconImage: (
    <StaticImage
      src="../../images/tretinoin@2x.png"
      width={80}
      alt="tretinoin"
    />
  ),
  shortName: 'Tr',
  tags: [
    IngredientInfoTags.FINE_LINES,
    IngredientInfoTags.ACNE,
    IngredientInfoTags.DARK_SPOTS,
  ],
};

export const ZINC_POP: IngredientsInfoPopContent = {
  ...ZINC,
  detailsText:
    'An antrimicrobial that helps reduce acne-contributing bacteria and fungi.',
  iconImage: (
    <StaticImage
      src="../../images/zincPyrithione@2x.png"
      width={80}
      alt="zinc pyrithione"
    />
  ),
  shortName: 'Zi',
  tags: [IngredientInfoTags.ACNE, IngredientInfoTags.INFLAMMATION],
};

export const TRANEXAMIC_POP: IngredientsInfoPopContent = {
  ...TRANEXAMIC,
  iconImage: (
    <StaticImage
      src="../../images/tranexamicAcid@2x.png"
      width={80}
      alt="tranexamic acid"
    />
  ),
  shortName: 'Tr A',
  tags: [IngredientInfoTags.DARK_SPOTS, IngredientInfoTags.REDNESS],
};

export const SPRIONOLACTONE_POP: IngredientsInfoPopContent = {
  name: 'spironolactone',
  title: 'Spironolactone',
  detailsText:
    'Helps stop the cycle of stubborn hormonal acne and reduces the skin’s oil production. Topical spironolactone is safe regardless of sex or gender.',
  iconImage: (
    <StaticImage
      src="../../images/spironolactone@2x.png"
      width={80}
      alt="spironolactone"
    />
  ),
  shortName: 'Sp',
  tags: [IngredientInfoTags.HORMONAL_ACNE],
};

export const MINOXIDIL_POP: IngredientsInfoPopContent = {
  ...MINOXIDIL,
  shortName: 'Mi',
  detailsText: '',
  tags: [
    IngredientInfoTags.THINNING_HAIR,
    IngredientInfoTags.PREVENTATIVE_HAIR_LOSS,
  ],
};

export const POP_INGREDIENTS: IngredientsInfoPopContent[] = [
  NIACINAMIDE_POP,
  TRETINOIN_POP,
  CLINDAMYCIN_POP,
  AZELIAC_POP,
  TRANEXAMIC_POP,
  ZINC_POP,
  METRONIDAZOLE_POP,
];

export const ACNE_INGREDIENTS: IngredientsInfoPopContent[] = [
  AZELIAC_ACNE,
  TRETINOIN_POP,
  CLINDAMYCIN_POP,
  SPRIONOLACTONE_POP,
  ZINC_POP,
];

export const CHIA_INGREDIENTS: IngredientsInfoPopContent[] = [
  {
    ...MINOXIDIL_POP,
    introText: 'Your hair formula might include: ',
  },
  {
    ...TRETINOIN_POP,
    detailsText: '',
    introText: 'Your skin formula might include: ',
    tags: [
      IngredientInfoTags.ACNE,
      IngredientInfoTags.DARK_SPOTS,
      IngredientInfoTags.PREVENTATIVE_AGING,
    ],
  },
];
